import React from 'react';
import { ListItemButton, Stack, Typography } from '@mui/material';

import palette from '@/theme/palette.ts';

type CroppedReplaceableImageProps = {
  croppedImageSrc: string;
  handleChangePictureClick: () => void;
};

export const CroppedReplaceableImage = ({
  croppedImageSrc,
  handleChangePictureClick,
}: CroppedReplaceableImageProps) => {
  return (
    <Stack alignItems="center" gap={1} minWidth={210}>
      <img
        src={croppedImageSrc}
        alt="Cropped"
        style={{ width: 210, height: 'auto', objectFit: 'cover', borderRadius: 8 }}
      />
      <ListItemButton onClick={handleChangePictureClick}>
        <Stack direction="row" gap={1}>
          <Typography
            variant="subtitle2"
            color="textSecondary"
            sx={{ textDecoration: 'underline' }}
          >
            Změnit obrázek
          </Typography>
          <span className="material-symbols-outlined" style={{ color: palette.text.secondary }}>
            replace_image
          </span>
        </Stack>
      </ListItemButton>
    </Stack>
  );
};
